<template>
  <div class="device-create-list">
    <div class="select-grade">
      <!-- <div class="text">搜索设备号：</div>  -->
      <el-input
        placeholder="请输入设备号"
        prefix-icon="el-icon-search"
        v-model="searchVal"
        @change="searchDevice"
        @clear="clear"
        clearable
      >
      </el-input>
    </div>
    <div class="select-class">
      <el-radio-group v-model="radio" v-if="deviceList != ''">
        <el-radio
          class="unbound-item"
          v-for="item in deviceList"
          :key="item.deviceId"
          :label="item.deviceId"
          >{{ item.deviceId }}</el-radio
        >
      </el-radio-group>
      <div class="none" v-else>暂无该设备号</div>
    </div>
    <div class="next-btn">
      <el-button type="primary" @click="determine"> 确认绑定 </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      deviceList: [], // 设备号列表
      searchVal: "",
      radio: "",
    };
  },
  inject: ["refresh"],
  props: {
    unboundList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    editStudentInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  created() {},
  mounted() {
    this.deviceList = this.unboundList;
  },
  watch: {
    unboundList: {
      handler(newVal, oldVal) {
        this.deviceList = newVal;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    determine() {
      console.log(this.radio);
      let device = this.deviceList.filter(
        (item) => this.radio == item.deviceId
      );
      let newDeviceId = this.radio;
      if (!this.radio) {
        this.$message.error("请选择新的设备号");
        return;
      }
      this.$confirm(
        `是否为${this.editStudentInfo.studentName}绑定新的设备:${device[0].deviceName}?`,
        "更改绑定",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.post(this.$url.updatestudentdevicebind, {
            studentId: this.editStudentInfo.studentId,
            deviceId: newDeviceId,
            updateBy: this.user.id,
          })
            .then((res) => {
              // console.log("更改绑定结果==>", res);
              if (res.code != 200) {
                this.$message.error("更改绑定失败!");
                return;
              }
              this.$message.success("更改绑定成功");
              // 刷新
              this.refresh();
              this.$emit("close");
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          // console.log("取消成功");
        });
    },
    searchDevice() {
      this.radio = "";
      // console.log(this.searchVal);
      if (this.searchVal == "") {
        this.deviceList = this.unboundList;
        return;
      }
      let result = this.deviceList.filter(
        (item) => item.deviceId.indexOf(this.searchVal) != -1
      );
      // console.log("搜索结果==>", result);
      this.deviceList = result;
    },
    clear() {
      this.radio = "";
      this.deviceList = this.unboundList;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./device-create-list.scss";
</style>